import React, { useId } from 'react';
import { Box } from '@mui/material';
import { drawReveal, fadeReveal } from './motion';

/** Tiny area line of the last few periods (96×32); nothing for fewer than two values. */
const Sparkline = ({ values = [], color = '#1f6f6a', width = 96, height = 32 }) => {
  const id = useId();
  const v = values.map(Number).filter((x) => !Number.isNaN(x));
  if (v.length < 2) return null;
  const min = Math.min(...v);
  const range = Math.max(...v) - min || 1;
  const pts = v.map((x, i) => [i * (width / (v.length - 1)), height - 4 - ((x - min) / range) * (height - 8)]);
  const line = pts.map((p, i) => `${i ? 'L' : 'M'}${p[0].toFixed(1)} ${p[1].toFixed(1)}`).join(' ');
  const last = pts[pts.length - 1];
  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} aria-hidden="true">
      <defs>
        <linearGradient id={id} x1="0" x2="0" y1="0" y2="1">
          <stop offset="0" stopColor={color} stopOpacity=".35" />
          <stop offset="1" stopColor={color} stopOpacity="0" />
        </linearGradient>
      </defs>
      <Box component="path" d={`${line} L${width} ${height} L0 ${height}Z`} fill={`url(#${id})`} sx={fadeReveal(500, 500)} />
      <Box component="path" d={line} pathLength="1" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" sx={drawReveal(300)} />
      <Box component="circle" cx={last[0]} cy={last[1]} r="2.8" fill={color} sx={fadeReveal(1050, 200)} />
    </svg>
  );
};

export default Sparkline;
